const _excluded = ["user_access"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
import { setIsUnderTechnicalReview } from '../store/features/reviewSlice';
import serviceMethods from './service_methods';
import { buildService } from './service';
import engagementTeamService from './claim_groups/engagement_team.service';
const api = buildService('/companies', {
  only: ['get']
});
let CompanyService = {};
CompanyService = {
  useFetch(_ref) {
    let {
      companyId,
      setLoading
    } = _ref;
    const [company, setCompany, fetchCompany] = serviceMethods.useFetch({
      callback: useCallback(async () => await api.get(companyId), [companyId]),
      setLoading,
      initialStateValue: null
    });
    return [company, setCompany, fetchCompany];
  },
  useRefresh(companyId, setCompanies, setLoading) {
    const refreshCompany = useErrorHandling(useCallback(async () => {
      setLoading(true);
      await this.refresh(companyId);
      const response = await this.all();
      setCompanies(response.companies);
    }, [companyId, setCompanies, setLoading]), () => setLoading(false));
    return refreshCompany;
  },
  useDelete(companyId, setCompanies, setLoading) {
    const deleteCompany = useErrorHandling(useCallback(async () => {
      if (window.confirm('Are you sure you wish to delete this company?')) {
        setLoading(true);
        await this.delete(companyId);
        const response = await this.all();
        setCompanies(response.companies);
      }
    }, [companyId, setCompanies, setLoading]), () => setLoading(false));
    return deleteCompany;
  },
  useUpdate(setCompany, setLoading) {
    let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    const updateCompany = useErrorHandling(useCallback(async company => {
      setLoading && setLoading(true);
      const updatedCompany = await this.update(company);
      setCompany(_objectSpread({}, updatedCompany));
      await callback(updatedCompany);
    }, [setCompany, setLoading, callback]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    return updateCompany;
  },
  useGetCompanyAndClaimGroup: function (companyId, claimGroupId) {
    let initialCompanyState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let initialClaimGroupState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    let setLoading = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : () => {};
    const [company, setCompany] = useState(initialCompanyState);
    const [claimGroup, setClaimGroup] = useState(initialClaimGroupState);
    const dispatch = useDispatch();
    const setClaimGroupFromCompany = useCallback(async company => {
      const selectedClaimGroup = company.claim_groups.find(c => c.id === Number(claimGroupId)) || company.claim_groups[0];
      const engagementTeam = await engagementTeamService.get(selectedClaimGroup.id);
      const userAccesses = [...engagementTeam.clients, ...engagementTeam.accountants].map(_ref2 => {
        let {
            user_access: userAccess
          } = _ref2,
          user = _objectWithoutProperties(_ref2, _excluded);
        return _objectSpread(_objectSpread({}, userAccess), {}, {
          user
        });
      });
      const freshClaimGroup = _objectSpread(_objectSpread({}, selectedClaimGroup), {}, {
        user_accesses: userAccesses,
        company: _objectSpread({}, company)
      });
      setClaimGroup(freshClaimGroup);
      dispatch(setIsUnderTechnicalReview(!!selectedClaimGroup.active_change_set));
    }, [claimGroupId, dispatch, setClaimGroup]);
    const updateCompany = CompanyService.useUpdate(setCompany, setLoading, useCallback(updatedCompany => {
      return setClaimGroupFromCompany(updatedCompany);
    }, [setClaimGroupFromCompany]));
    const fetchCompanyAndClaimGroup = useErrorHandling(useCallback(async () => {
      if (companyId && claimGroupId) {
        const fetchedCompany = await CompanyService.get(companyId);
        await setClaimGroupFromCompany(fetchedCompany);
        setCompany(fetchedCompany);
      }
    }, [companyId, claimGroupId, setClaimGroupFromCompany]));
    useEffect(() => {
      fetchCompanyAndClaimGroup();
    }, [fetchCompanyAndClaimGroup]);
    return [company, setCompany, claimGroup, setClaimGroup, fetchCompanyAndClaimGroup, updateCompany];
  },
  all: function () {
    let queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return fetch("/api/companies?".concat(queryParams), request.get);
  },
  get: company_id => {
    return fetch("/api/companies/".concat(company_id), request.get);
  },
  update: company => {
    return fetch("/api/companies/".concat(company.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        company
      })
    }));
  },
  delete: company_id => {
    return fetch("/api/companies/".concat(company_id), request.delete);
  }
};
export { CompanyService };